import React from 'react'

import { Alert, Box, Text } from '@factorialco/deprecated-design-system'

import LabeledInput from 'modules/core/components/LabeledInput'
import i18n from 'modules/core/lib/i18n'

import { ESIGNATURE_MAX_FILE_SIZE } from 'modules/documents/lib/constants'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import BaseList, {
  IPreviewData,
} from 'modules/processes/components/ItemWizard/components/FilesList/base'
import { Item } from 'modules/processes/domain'
import { useSignatureDocuments } from 'modules/processes/hooks/useSignatureDocuments'

export type FileUpdates = {
  filesToAdd: File[]
  filesToRemove: Set<number>
}

type Props = {
  item?: Item
  onFileUpdates: (fileUpdates: FileUpdates) => void
  folderId?: number
}

const SignatureDocumentsList = ({ item, onFileUpdates }: Props) => {
  const [currentFiles, setCurrentFiles] = React.useState<File[]>([])
  const files = useSignatureDocuments(item?.configurationId ?? undefined)
  const { setPreviewValues } = usePreviewProvider()
  const hasFiles =
    (files.currentFiles?.length || 0) + files.filesToAdd.length - files.filesToRemove.size > 0

  const setCustomPreviewData = (preview: IPreviewData) => {
    const data = {
      signDocument: {
        ...preview,
      },
    }
    setPreviewValues((prev) => ({
      ...prev,
      ...data,
    }))
  }

  const onFileUpdatesFunction = (fileUpdates: FileUpdates) => {
    onFileUpdates(fileUpdates)
    setCurrentFiles(fileUpdates.filesToAdd)
  }

  const warningSize = currentFiles.some((file) => file.size > ESIGNATURE_MAX_FILE_SIZE)

  return (
    <Box gap="s8">
      <LabeledInput
        mandatory
        isLegend
        value={hasFiles ? String(hasFiles) : undefined}
        label={i18n.t('processes.process_settings.wizard.attachments.form')}
      >
        <BaseList
          files={files}
          onFileUpdates={onFileUpdatesFunction}
          acceptedTypes={{ 'application/pdf': ['.pdf'] }}
          multiple={false}
          mandatory
          setCustomPreviewData={setCustomPreviewData}
        />
      </LabeledInput>

      {warningSize && (
        <Alert color="warning">
          <Text.Normal size="300" color="grey1000">
            {i18n.t('documents.beta.file_errors.max_file_size_esignature')}
          </Text.Normal>
        </Alert>
      )}
    </Box>
  )
}

export default SignatureDocumentsList
